import { Input } from 'antd'

export const InputLocation = (props) => {
  return <Input className='input-location' placeholder={`${props.type === "location" ? "Input location here" : ""}`} style={{ maxWidth: '450px' }} {...props} />
}
